import { render } from "./UIControls.vue?vue&type=template&id=6468d79a"
import script from "./UIControls.vue?vue&type=script&lang=js"
export * from "./UIControls.vue?vue&type=script&lang=js"

import "./UIControls.vue?vue&type=style&index=0&id=6468d79a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__